import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useLang } from "@/i18n";
import { Shell } from "@/components/Shell";
import { money } from "@/lib/format";
import { BarChart, Bar, XAxis, ResponsiveContainer, Cell } from "recharts";
import { CaretLeft } from "@phosphor-icons/react";

export default function MRDashboard() {
  const { t } = useLang();
  const nav = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/dashboard/mr").then(({ data }) => setD(data)); }, []);
  if (!d) return <Shell title={t("dashboard")} nav={false}><p className="text-slate-400">{t("loading")}</p></Shell>;

  const chartData = Object.entries(d.month_product_detailing || {}).map(([name, value]) => ({ name: name.split(" ")[0], value }));
  const cards = [
    { label: t("completed_calls"), value: d.today?.total_visits || 0 },
    { label: t("call_target"), value: d.call_target },
    { label: t("order_value"), value: money(d.today?.order_value) },
    { label: t("collection"), value: money(d.today?.collection) },
    { label: "Month Visits", value: d.month_visits },
    { label: "Working Days", value: d.month_working_days },
    { label: "Call Avg / Day", value: d.month_call_avg },
    { label: "Month Orders", value: money(d.month_order_value) },
  ];

  return (
    <Shell title={t("dashboard")} nav={false}
      back={<button onClick={() => nav("/")} data-testid="back-btn"><CaretLeft size={22} /></button>}>
      <div className="grid grid-cols-2 gap-3">
        {cards.map((c) => (
          <div key={c.label} className="rounded-xl bg-white border border-slate-200 p-4">
            <div className="font-head font-extrabold text-xl text-slate-800">{c.value}</div>
            <div className="text-[11px] text-slate-500 uppercase tracking-wide mt-1">{c.label}</div>
          </div>
        ))}
      </div>

      {chartData.length > 0 && (
        <div className="mt-4 rounded-xl bg-white border border-slate-200 p-4">
          <h3 className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-3">Product Detailing (Month)</h3>
          <ResponsiveContainer width="100%" height={180}>
            <BarChart data={chartData}>
              <XAxis dataKey="name" tick={{ fontSize: 10 }} />
              <Bar dataKey="value" radius={[6, 6, 0, 0]}>
                {chartData.map((_, i) => <Cell key={i} fill="#10B981" />)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </Shell>
  );
}
